import { isCommcgiRequest, fixUrl, isMagicRequest, cgitest } from './utils';

/*
tvConfig = {
  "islogin": "http://1.tv.aiseet.atianqi.com/tv/tv_mf_login_proxy",
  "magicproxy": "http://1.tv.aiseet.atianqi.com/i-tvbin/pay/tv_mf_proxy",
  "bossreport": "http://btrace.qq.com/kvcollect/",
  "sviplevel": "http://1.tv.aiseet.atianqi.com/i-tvbin/tv/common-cgi/caiyun_proxy/tv_payvip_proxy",
  "wujicache": "http://vqq.play.aiseet.atianqi.com/cache/wuji/object",
  "wujicgi": "http://wuji.play.aiseet.atianqi.com/fcgi-bin/wuji"
}
*/


const getProxyAddr = (url) => {
  // hostname + pathname -> name
  const requestMap = {
    'v.qq.com/cache/wuji/object': 'wujicache',
    'wuji.video.qq.com/fcgi-bin/wuji': 'wujicgi',
    'activity.video.qq.com/fcgi-bin/asyn_activity': 'magicproxy',
    'btrace.qq.com/kvcollect': 'bossreport',
    'vip.video.qq.com/fcgi-bin/comm_cgi': 'magicproxy',
  };
  const u = new URL(url);
  console.log(`getProxyAddr, url: ${JSON.stringify(u)}, hostname: ${u.hostname}, pathname: ${u.pathname}, key: ${u.hostname + u.pathname}, requestMap: ${JSON.stringify(requestMap)}, tvConfig: ${JSON.stringify(window.tvConfig || {})}`);
  const proxyName = requestMap[u.hostname + u.pathname];
  return window.tvConfig?.[proxyName];
};

const tvProxyInterceptor = (req) => {
  const request = req;
  const { url } = request.options;
  const fullUrl = fixUrl(url);
  let { data = {} } = request.options;
  // TV页面场景，需要从全局的window.tv_config下取代理cgi地址
  const proxyAddr = getProxyAddr(fullUrl);
  console.log(`tvProxyInterceptor, proxyAddr: ${proxyAddr}`);
  if (!proxyAddr) return request;

  const [, search] = url.split('?');
  // eslint-disable-next-line
  request.options.url = proxyAddr + (search && `?${search}` || '');
  request.options.otype = 'jsonp';
  console.log(`tvProxyInterceptor, request: ${JSON.stringify(request)}`);
  if (cgitest() && (isCommcgiRequest(fullUrl) || isMagicRequest(fullUrl))) {
    data = {
      cgitest: cgitest(),
      ...data,
    };
  }
  if (isCommcgiRequest(fullUrl)) {
    // 针对 commcgi 魔方也做了一层代理，所以当在TV上请求commcgi时，路径是
    // request -> tv cgi(proxy) -> magic common cgi(proxy) -> commcgi
    // 这里针对commcgi的请求，加上魔方代理请求时的参数
    data = {
      magic_trans_type: 'commcgi',
      ...data,
    };
  }
  request.options.data = data;
  return request;
};

const processXHR = () => {
  if (typeof XMLHttpRequest === 'undefined') {
    return;
  }

  const originalopen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (type, url, ...rest) {
    if (url.startsWith('http')) {
      const u = new URL(url);
      if (u.hostname === 'btrace.video.qq.com') {
        const [, search] = url.split('?');
        const uu = `${window.tvConfig?.bossreport || ' http://btrace.video.qq.com/kvcollect'}?${search}`;
        return originalopen.bind(this)(type, uu, ...rest);
      }
    }
    let newUrl = url;
    const proxyAddr = getProxyAddr(fixUrl(url));
    if (proxyAddr) {
      const [, search] = url.split('?');
      newUrl = proxyAddr + ((search && `?${search}`) || '');
    }
    return originalopen.bind(this)(type, newUrl, ...rest);
  };
};

export { processXHR };

export default tvProxyInterceptor;
